import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/Navigation.css';

const Navigation = () => {
  const location = useLocation();
  const { language, t, changeLanguage } = useLanguage();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const getCurrentPath = () => {
    const path = location.pathname;
    const pathParts = path.split('/').filter(Boolean);
    // Remove language code if present
    if (pathParts[0] === 'es' || pathParts[0] === 'en') {
      return '/' + pathParts.slice(1).join('/') || '/';
    }
    return path;
  };

  const getLocalizedPath = (path) => {
    const currentPath = getCurrentPath();
    const targetPath = path === '/' && currentPath === '/' ? '' : path;
    return `/${language}${targetPath}`;
  };

  const isActive = (path) => {
    const currentPath = getCurrentPath();
    return currentPath === path ? 'active' : '';
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };


  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to={getLocalizedPath('/')} className="logo" onClick={closeMobileMenu}>
          <img src="/BRIOLOGO.png" alt="BRIOMOL Logo" className="logo-img" />
        </Link>
        {isMobileMenuOpen && (
          <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
        )}
        <ul className={`nav-menu ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
          <li>
            <Link to={getLocalizedPath('/')} className={isActive('/')} onClick={closeMobileMenu}>
              {t('nav.home')}
            </Link>
          </li>
          <li>
            <Link to={getLocalizedPath('/about')} className={isActive('/about')} onClick={closeMobileMenu}>
              {t('nav.about')}
            </Link>
          </li>
          <li>
            <Link to={getLocalizedPath('/products')} className={isActive('/products')} onClick={closeMobileMenu}>
              {t('nav.products')}
            </Link>
          </li>
          <li>
            <Link to={getLocalizedPath('/contact')} className={isActive('/contact')} onClick={closeMobileMenu}>
              {t('nav.contact')}
            </Link>
          </li>
        </ul>
        <div className="language-switcher">
          <button
            onClick={() => changeLanguage('es')}
            className={language === 'es' ? 'lang-btn active' : 'lang-btn'}
            aria-label="Spanish"
          >
            ES
          </button>
          <button
            onClick={() => changeLanguage('en')}
            className={language === 'en' ? 'lang-btn active' : 'lang-btn'}
            aria-label="English"
          >
            EN
          </button>
        </div>
        <button
          className={`hamburger ${isMobileMenuOpen ? 'hamburger-open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
